import { Component, inject, OnInit } from '@angular/core';
import { UtilityToolbarComponent } from '../../shared-components/utility-toolbar/utility-toolbar.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { RightBridgeApiService } from '../../services/right-bridge-api.service';
import {
  KENDO_PDFVIEWER,
  PDFViewerTool,
} from '@progress/kendo-angular-pdfviewer';
import { NgxLoadingModule } from 'ngx-loading';
import { SessionStorageService } from '../../services/session-storage.service';

@Component({
  selector: 'app-hot-rates',
  imports: [
    UtilityToolbarComponent,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    KENDO_PDFVIEWER,
    NgxLoadingModule,
  ],
  templateUrl: './hot-rates.component.html',
  styleUrl: './hot-rates.component.scss',
})
export class HotRatesComponent implements OnInit {
  private rbs = inject(RightBridgeApiService);
  private ss = inject(SessionStorageService);
  private latestRequestId = 0;
  loading: boolean = false;
  annuityType: string = 'ALL';
  pdfData: any;
  pdfViewerTools: PDFViewerTool[] = [
    'pager',
    'spacer',
    'zoom',
    'zoomInOut',
    'selection',
    'print',
    'download',
  ];

  ngOnInit(): void {
    this.loadFileIntoViewer();
  }

  onFormValueChange() {
    this.loadFileIntoViewer();
  }

  loadFileIntoViewer() {
    const requestId = ++this.latestRequestId;
    const globals = this.ss.get('globals');
    const payload = {
      ReportType: 'template',
      parameters: { UnitID: globals.firmId, Type: this.annuityType },
      UIConfig: 'hot-rates',
    };
    this.loading = true;
    this.rbs.getCustomReport(payload, 'aw').subscribe(
      resp => {
        const reader = new FileReader();
        reader.onloadend = () => {
          if (requestId !== this.latestRequestId) {
            return;
          }

          const result = typeof reader.result === 'string' ? reader.result : '';
          this.pdfData = result.includes(',')
            ? result.split(',', 2)[1]
            : result;
          this.loading = false;
        };

        reader.onerror = () => {
          if (requestId !== this.latestRequestId) {
            return;
          }

          this.pdfData = null;
          this.loading = false;
        };
        reader.readAsDataURL(resp);
      },
      () => {
        if (requestId !== this.latestRequestId) {
          return;
        }

        this.pdfData = null;
        this.loading = false;
      }
    );
  }
}
